'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.fetch = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../action-types');

var fetch = exports.fetch = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_BREADCRUMBS_FETCH, function (categoryId) {
	return v12.util.http.get('/api/breadcrumbs', { query: { categoryId: categoryId } }).then(function (_ref) {
		var body = _ref.body;
		return {
			categoryId: categoryId,
			data: body.hits.reverse()
		};
	});
});